export enum ChatState {
  Library = 'library',
  EventApp = 'event_app',
  RocketChat = 'rocket_chat',
}
